import ReviewAttribute from "../../../Components/SharedComponent/ReviewAttribute/ReviewAttribute";

const AdditionalCommentsOverview = ({ data }) => {
  if (!data) return null;
  const data1 = data["9_0"];
  const { additional_comment } = data1;
  return (
    <div className="forms-instance" style={{ color: "#111" }}>
      <div i2c-grid="grid grid" className="review-summary-gap">
        <ReviewAttribute
          label="Additional Comments"
          value={additional_comment?.length ? additional_comment : "-"}
          fullWidth={true}
        />
      </div>
    </div>
  );
};
export default AdditionalCommentsOverview;
